import { Banner, DataTable, Text } from '@dixa/lib-shared-habla';

import { UserBansEndpointResult } from 'hooks/useBans';
import { UserBan } from 'hooks/useBans/types';

import { banHistoryColumns, banHistorySubColumns } from './columns';

const bansLoading = <Text.Paragraph>Loading bans history...</Text.Paragraph>;

const bansFailed = (
  <Banner
    variant="fail"
    icon={null}
    description={
      <Text.Paragraph>
        An error occurred while loading bans history
      </Text.Paragraph>
    }
  />
);

const bansEmpty = (
  <Banner
    variant="info"
    icon={null}
    description={
      <Text.Paragraph>
        There are no previous bans on any channels
      </Text.Paragraph>
    }
  />
);

type UserBanHistoryProps = Pick<
  UserBansEndpointResult,
  | 'items'
  | 'asyncStatus'
  | 'hasNextPage'
  | 'hasPreviousPage'
  | 'nextPage'
  | 'previousPage'
>;

export const UserBanHistory = ({
  items,
  asyncStatus,
  hasNextPage,
  hasPreviousPage,
  nextPage,
  previousPage,
}: UserBanHistoryProps): JSX.Element | null => {
  if (asyncStatus === 'failed') {
    return bansFailed;
  }

  if (!items.length) {
    if (asyncStatus === 'loading') {
      return bansLoading;
    }

    return bansEmpty;
  }

  return (
    <DataTable<UserBan, UserBan>
      data={items}
      columns={banHistoryColumns}
      subTableDataSelector={(data) =>
        data.unbanned_at || data.unbanning_agent ? [data] : []
      }
      subTableColumns={banHistorySubColumns}
      paginationProps={{
        loading: asyncStatus === 'loading',
        previousButtonDisabled: !hasPreviousPage,
        nextButtonDisabled: !hasNextPage,
        previousButtonClick: previousPage,
        nextButtonClick: nextPage,
      }}
    />
  );
};
